import GetAndUploadTemplate from './GetAndUploadTemplate.component';

export default GetAndUploadTemplate;
